__turbopack_context__.v({
  "disabled": "type-biens-module__gO7AsW__disabled",
  "ideeri": "type-biens-module__gO7AsW__ideeri",
  "ideeri-secondary": "type-biens-module__gO7AsW__ideeri-secondary",
  "label": "type-biens-module__gO7AsW__label",
  "secondary": "type-biens-module__gO7AsW__secondary",
  "tbPanel": "type-biens-module__gO7AsW__tbPanel",
});
